import React, { createContext, useContext } from "react";

import { CarePlanDirectives } from "@/models/CarePlanDirectivesModel.ts";
import { RenewType } from "@/models/PatientRenewalInfoModel.ts";

type RenewalContextType = {
  carePlanDirectives: CarePlanDirectives;
  renewalType: RenewType;
};

export const RenewalContext = createContext<RenewalContextType | null>(null);

interface RenewalProviderProps {
  carePlanDirectives: CarePlanDirectives;
  children: React.ReactNode;
  renewalType: RenewType;
}

export const RenewalProvider: React.FC<RenewalProviderProps> = ({ carePlanDirectives, renewalType, children }) => {
  return <RenewalContext.Provider value={{ carePlanDirectives, renewalType }}>{children}</RenewalContext.Provider>;
};

export const useRenewalContext = () => {
  const context = useContext(RenewalContext);
  if (!context) {
    throw new Error("useRenewalContext must be used within a RenewalProvider");
  }
  return context;
};
